module.exports = __webpack_public_path__ + "img/Pot2.31212e6b.svg";